import { useId } from 'react'
import type { ReactNode } from 'react'
import styles from './Toggle.module.css'

interface ToggleProps {
  label: string
  hint?: ReactNode
  checked: boolean
  onChange: (checked: boolean) => void
  danger?: boolean
  noBorder?: boolean
}

export function Toggle({ label, hint, checked, onChange, danger, noBorder }: ToggleProps) {
  const id = useId()
  return (
    <div className={styles.row} style={noBorder ? { borderBottom: 'none' } : undefined}>
      <div className={styles.info}>
        <label
          htmlFor={id}
          className={styles.label}
          style={danger ? { color: 'var(--red)' } : undefined}
        >
          {label}
        </label>
        {hint && <div className={styles.hint}>{hint}</div>}
      </div>
      <label className={styles.toggle} htmlFor={id}>
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
        />
        <div className={styles.track} />
        <div className={styles.thumb} />
      </label>
    </div>
  )
}
